import script from "./tagSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./tagSelector.vue?vue&type=script&setup=true&lang=js"

import "./tagSelector.vue?vue&type=style&index=0&id=32f083b7&lang=scss"

const __exports__ = script;

export default __exports__